export const getApiBaseUrl = (): string => {
  // 1. Professional approach: Check for environment variables set in .env.local, .env.dev, .env.prod
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // 2. Fallback: Dynamic determination based on URL (as requested for localhost/dev2)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // If URL contains localhost, it is local
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'https://api-dev.hermesplatform.com';
    }
    
    // If URL contains dev2, it is dev
    if (hostname.includes('dev2')) {
      return 'https://api-dev.hermesplatform.com';
    }
  }

  // Otherwise consider it production
  return 'https://api.hermesplatform.com';
};

export const API_BASE_URL = getApiBaseUrl();
